import React from 'react';
import { Button, Modal, Tooltip } from '@clearcover/atlas';
import { AxiosPromise } from 'axios';
import {
  GetPaymentsSummaryByTermNumberResponse,
  PaymentsAndBillingInfoType,
} from '@clearcover/core-app-types';

import { EditBillingInfo } from '../EditBillingInfo';
import { EditPayPlan } from '../EditPayPlan';
import { PaymentFrequencySection } from '../PaymentFrequencySection';
import styles from './styles.module.css';
import { usePolicyContext } from 'Policies/utils';

export type EditPaymentsAndPayPlanSectionProps = {
  billingInfo?: PaymentsAndBillingInfoType;
  bindDate?: string;
  loading: boolean;
  fetchBillingData: () =>
    | AxiosPromise<GetPaymentsSummaryByTermNumberResponse>
    | Promise<void>;
  isRenewalDraft: boolean;
  canEditPayPlan: boolean;
  payPlanTooltipMessage: string;
};

export const EditPaymentsAndPayPlanSection = ({
  billingInfo,
  bindDate,
  loading,
  fetchBillingData,
  isRenewalDraft,
  canEditPayPlan,
  payPlanTooltipMessage,
}: EditPaymentsAndPayPlanSectionProps) => {
  const {
    flags: { mandatedDownPay },
  } = usePolicyContext();

  return (
    <div className={styles.container}>
      <div className={styles.buttonRow}>
        <Modal
          variant="full"
          data-testid="payment-settings-modal"
          toggle={(open) => (
            <Button
              className={styles.button}
              variant="secondary"
              onClick={open}
              data-testid="payment-settings-button"
            >
              Payment Settings
            </Button>
          )}
        >
          {() => (
            <EditBillingInfo
              billingInfo={billingInfo}
              bindDate={bindDate}
              loading={loading}
              fetchBillingData={fetchBillingData}
              isRenewalDraft={isRenewalDraft}
            />
          )}
        </Modal>

        <Modal
          variant="full"
          data-testid="edit-pay-plan-modal"
          toggle={(open) => (
            <Tooltip tooltip={payPlanTooltipMessage}>
              <Button
                className={styles.button}
                variant="secondary"
                disabled={!canEditPayPlan}
                onClick={open}
                data-testid="edit-pay-plan-button"
              >
                Edit pay plan
              </Button>
            </Tooltip>
          )}
        >
          {(close) =>
            billingInfo?.version === 'v3' ? (
              <EditPayPlan
                billingInfo={billingInfo}
                isRenewalDraft={isRenewalDraft}
                close={close}
              />
            ) : (
              <PaymentFrequencySection
                billingInfo={billingInfo}
                billingInfoLoading={loading}
                isRenewalDraft={isRenewalDraft}
                fetchBillingData={fetchBillingData}
                mandatedDownPay={mandatedDownPay}
              />
            )
          }
        </Modal>
      </div>
    </div>
  );
};
